<template>
    <div class="mt-3">
        <div class="data-container">
            <b-table :items="list"
                :fields="fields"
                :current-page="param.page"
                ref="AssetMasterList"
                responsive
                show-empty
                :empty-text="(loading) ? 'Loading data' : 'No Data Available'">
                <template slot="amount" slot-scope="data">
                    <span :class="{
                        'text-danger': data.item.amount < 1
                    }">
                        {{ data.value }}
                    </span>
                </template>
            </b-table>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

const formatter = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 10
});

export default {
    name: "TransactionUploadTable",
    data() {
        return {
            fields: [
                {
                    key: "membership_id",
                    sortable: true,
                    label: "Membership ID"
                },
                {
                    key: "isr_code",
                    sortable: true,
                    label: "ISR Code"
                },
                {
                    key: "date",
                    sortable: true,
                    label: "Transaction Date",
                    formatter: value => {
                        return this.$moment(value).format("DD MMM YYYY");
                    }
                },
                {
                    key: "transaction_number",
                    sortable: true,
                    label: "Tracking No."
                },
                {
                    key: "amount",
                    sortable: true,
                    formatter: value => {
                        return "PHP " + formatter.format(value);
                    }
                },
                {
                    key: "type",
                    sortable: true,
                    label: "Transaction Type"
                },
                {
                    key: "description",
                    sortable: true,
                    label: "Transaction Type Description"
                }
            ]
        };
    },
    computed: {
        ...mapState("reportsTransactionUpload", ["loading", "param", "list"])
    },
    created: async function() {
        await this.getList();
    },
    methods: {
        getList: async function() {
            await this.$store.commit("reportsTransactionUpload/setParam", {
                range: this.param.range,
                page: this.param.page
            });
            await this.$store.dispatch("reportsTransactionUpload/getList", this.param);
        }
    }
}
</script>
